import React from 'react';

import {hooks} from '../hooks';
import {ActivitiesType} from '../types';
  
type Props = {
  index: number;
  activity: ActivitiesType;
  isLast: boolean;
};

export const ActivitiesItem: React.FC<Props> = ({index, activity, isLast}) => {
  const navigate = hooks.useNavigate();

  return (
    <>
    <div
      style={{
        padding: 14,
        paddingTop: 14,
        paddingBottom: 14,
        borderRadius: 10,
        position: 'relative',
        marginBottom: 15,
        backgroundColor: 'var(--white-color)',
        display: 'block',
        height: 'auto',
        maxHeight: "100%",
      }}
      onClick={() => navigate(`/detail-activities/${activity.id}`, {state: {activity}})}
    >
      <div>
        <img
          src={activity.banner}
          alt={activity.title}
          style={{width: '100%', borderRadius: 6, objectFit: 'cover', height: 160}}
        />
        <div className='row-center-space-between' style={{paddingTop: 10}}>
          <h4 className='number-of-lines-2' style={{padding: '6px 0 0 0'}}>{activity.title}</h4>
          <p className='t10'>
            {activity.date}
          </p>
        </div>
      </div>
      {/* <components.Name
        son={son.name}
        containerStyle={{marginBottom: 3}}
      /> */}
      <div style={{width: '100%'}}>
        <p className='t10'>{activity.subtitle}</p>
        <p className='t12 number-of-lines-3' style={{marginBottom: 10, overflow: 'hidden', paddingTop: 10}}>{activity.short_description}</p>
      </div>
    </div>
    </>
  );
};
